import styled from "styled-components";

export const ClientSettingsDropdownListTitleBox = styled.div`
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 1%;
    margin-block: 10px;
`